module.exports = __webpack_public_path__ + "img/plri.95ee4c8c.png";